/**
 * DisplayJob list fields are typed as string[] but some pipelines store a single string.
 * JSON-LD JobPosting expects comma-separated Text for these properties.
 */
export function joinDisplayJobTextList(val: string | string[] | undefined | null): string | undefined {
  if (val === undefined || val === null) return undefined;
  if (typeof val === 'string') {
    const t = val.trim();
    return t === '' ? undefined : t;
  }
  if (Array.isArray(val)) {
    const parts = val
      .map((x) => (typeof x === 'string' ? x.trim() : String(x)))
      .filter((x) => x !== '');
    return parts.length === 0 ? undefined : parts.join(', ');
  }
  return undefined;
}
